import Link from 'next/link';

import { cn } from '@kit/ui/utils';

import { FMARK, getThemeColors } from './constants';
import type { FlowLogoIconProps } from './types';

/**
 * FlowLogoIcon - Favicon/Small Icon variant
 * Three stacked pill shapes forming an "F" (the F-mark)
 * Pure static SVG — no animation, uses currentColor for theme adaptation
 */
export function FlowLogoIcon({
  className,
  size = 32,
  theme = 'light',
  color,
  href,
  'aria-label': ariaLabel = 'Flow',
}: FlowLogoIconProps) {
  const colors = getThemeColors(theme);
  const fillColor = color || colors.primary;
  const scale = size / FMARK.h; // scale relative to icon height (60)

  const svg = (
    <svg
      viewBox={`0 0 ${FMARK.w} ${FMARK.h}`}
      width={FMARK.w * scale}
      height={FMARK.h * scale}
      className={cn('inline-block', className)}
      fill={fillColor}
      aria-label={ariaLabel}
      role="img"
    >
      <rect
        x="0"
        y="0"
        width={FMARK.widths[0]}
        height={FMARK.barH}
        rx={FMARK.rx}
      />
      <rect
        x="0"
        y={FMARK.barH + FMARK.barGap}
        width={FMARK.widths[1]}
        height={FMARK.barH}
        rx={FMARK.rx}
      />
      <rect
        x="0"
        y={(FMARK.barH + FMARK.barGap) * 2}
        width={FMARK.widths[2]}
        height={FMARK.barH}
        rx={FMARK.rx}
      />
    </svg>
  );

  if (href != null) {
    return (
      <Link href={href} aria-label={ariaLabel} prefetch={true}>
        {svg}
      </Link>
    );
  }

  return svg;
}
